/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  has,
  assign,
  fromPairs,
} from 'lodash';
import { Tooltip } from 'react-bootstrap';
import AutoColor from '../AutoColor';
import styles from './styles.scss';

const defaultProps = {
  content: null,
  enums: null,
  theme: 'auto',
  shift: null,
  translateMap: null,
  inverse: false,
};

const propTypes = {
  content: React.PropTypes.any,
  translateMap: React.PropTypes.object,
  shift: React.PropTypes.number,
  theme: React.PropTypes.string,
  enums: React.PropTypes.oneOfType([
    React.PropTypes.array,
    React.PropTypes.func,
  ]),
  inverse: React.PropTypes.bool,
};

class RichLabel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
    };
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.tooltips = {};
  }

  handleMouseOver() {
    this.timeout = setTimeout(() => {
      this.setState({ hovered: true });
    }, 200);
  }

  handleMouseOut() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({ hovered: false });
  }

  content() {
    const { enums, content } = this.props;
    let { translateMap } = this.props;

    // translateMap is deprecated, when enums is used, translateMap is overwrite
    if (enums) {
      if (_.isArray(enums)) {
        translateMap = assign(
          translateMap,
          fromPairs(
            enums
              .filter(e => has(e, 'translate'))
              .map(e => [e.content, e.translate])));
      } else if (_.isFunction(enums)) {
        const e = enums(content);
        if (_.has(e, 'translate')) {
          translateMap = ({
            ...translateMap,
            [content]: e.translate,
          });
        }
      }
    }

    if (translateMap) {
      const label = translateMap[content] || content;
      let tooltip = this.tooltips[content];
      if (!tooltip) {
        tooltip = (
          <Tooltip placement="top" className="in" id="tooltip">{content}</Tooltip>
        );
        this.tooltips[content] = tooltip;
      }
      return (
        <span
          className={styles.translated}
          onMouseOver={this.handleMouseOver}
          onMouseOut={this.handleMouseOut}
        >
          {this.state.hovered && tooltip}
          {label}
        </span>
      );
    }
    return content;
  }

  render() {
    const {
      inverse,
      theme,
      shift,
      enums,
      content,
    } = this.props;

    return (
      <AutoColor
        className={`${styles.richLabel}`}
        inverse={inverse}
        content={content}
        theme={theme}
        shift={shift}
        enums={enums}
      >
        {this.content()}
      </AutoColor>
    );
  }
}

RichLabel.propTypes = propTypes;
RichLabel.defaultProps = defaultProps;

export default RichLabel;




// WEBPACK FOOTER //
// ./src/components/RichLabel/index.jsx